class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

(() => {
  if (window.ReadywearPromoProgressAssetLoader) return;
  window.ReadywearPromoProgressAssetLoader = true;

  const currentScript = document.currentScript || document.querySelector('script[src*="cart-drawer.js"]');
  const cartDrawerAssetUrl = currentScript && currentScript.src;
  if (!cartDrawerAssetUrl) return;

  const assetUrl = (filename) => cartDrawerAssetUrl.replace('cart-drawer.js', filename);
  const cacheSuffix = cartDrawerAssetUrl.includes('?') ? '&rw_promo=20260713-b1f1' : '?rw_promo=20260713-b1f1';
  const cssHref = `${assetUrl('readywear-promo-progress.css')}${cacheSuffix}`;
  const jsSrc = `${assetUrl('readywear-promo-progress.js')}${cacheSuffix}`;

  if (!document.querySelector('link[href*="readywear-promo-progress.css"]')) {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = cssHref;
    document.head.appendChild(link);
  }

  if (!document.querySelector('script[src*="readywear-promo-progress.js"]')) {
    const script = document.createElement('script');
    script.src = jsSrc;
    script.defer = true;
    document.head.appendChild(script);
  }
})();

(() => {
  if (window.ReadywearCrossSellAssetLoader) return;
  window.ReadywearCrossSellAssetLoader = true;

  const currentScript = document.currentScript || document.querySelector('script[src*="cart-drawer.js"]');
  const cartDrawerAssetUrl = currentScript && currentScript.src;
  if (!cartDrawerAssetUrl) return;

  const assetUrl = (filename) => cartDrawerAssetUrl.replace('cart-drawer.js', filename);
  const cacheSuffix = cartDrawerAssetUrl.includes('?') ? '&rw_cross_sell=20260616-color1' : '?rw_cross_sell=20260616-color1';
  const cssHref = `${assetUrl('readywear-cross-sell.css')}${cacheSuffix}`;
  const jsSrc = `${assetUrl('readywear-cross-sell.js')}${cacheSuffix}`;

  if (!document.querySelector('link[href*="readywear-cross-sell.css"]')) {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = cssHref;
    document.head.appendChild(link);
  }

  if (!document.querySelector('script[src*="readywear-cross-sell.js"]')) {
    const script = document.createElement('script');
    script.src = jsSrc;
    script.defer = true;
    document.head.appendChild(script);
  }
})();
